/**
 * @deprecated Use PRODUCT_ROUTES instead
 */
export const PRODUCT = {
  HOME: 'product',
  MASTER_PP: 'master-pp',
  VISIBLE_BY_VERIZON_DRAWER: 'visible_by_verizon_drawer',
  PROCESSOR_DRAWER: 'processor_drawer',
  MACBOOK_PROCESSOR_DRAWER: 'macbook_processor_drawer',
  LAPTOP_PROCESSOR_DRAWER: 'laptop_processor_drawer',
  OBSOLETE_DRAWER: 'obsolete_drawer',
  OBSOLETE_SOFTWARE_DRAWER: 'obsolete_software_drawer',
  OBSOLETE_OS_DRAWER: 'obsolete_os_drawer',
  JP_VERIFIED_REFURBISHED_DRAWER: 'jp_verified_refurbished_drawer',
}

export const PRODUCT_ROUTES = {
  VARIANT_PRODUCT_PAGE: PRODUCT.HOME,
  MASTER_PRODUCT_PAGE: PRODUCT.MASTER_PP,
  WEBVIEWS_VISIBLE_BY_VERIZON_DRAWER: PRODUCT.VISIBLE_BY_VERIZON_DRAWER,
  WEBVIEWS_PROCESSOR_DRAWER: PRODUCT.PROCESSOR_DRAWER,
  WEBVIEWS_MACBOOK_PROCESSOR_DRAWER: PRODUCT.MACBOOK_PROCESSOR_DRAWER,
  WEBVIEWS_LAPTOP_PROCESSOR_DRAWER: PRODUCT.LAPTOP_PROCESSOR_DRAWER,
  WEBVIEWS_OBSOLETE_DRAWER: PRODUCT.OBSOLETE_DRAWER,
  WEBVIEWS_OBSOLETE_SOFTWARE_DRAWER: PRODUCT.OBSOLETE_SOFTWARE_DRAWER,
  WEBVIEWS_OBSOLETE_OS_DRAWER: PRODUCT.OBSOLETE_OS_DRAWER,
  WEBVIEWS_JP_VERIFIED_REFURBISHED_DRAWER:
    PRODUCT.JP_VERIFIED_REFURBISHED_DRAWER,
}
